/**
 * @module PC向けフッター部共通コンポーネント
 */
import store from './../../store';
import router from './../../router';
export default {
  name: 'PCFooter',
  data(vm) {
    return {
      copyRight: vm.$vuetify.lang.t('$vuetify.copyRight'),
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        copyRight: vm.$vuetify.lang.t('$vuetify.copyRight'),
      };
    },
  },
  methods: {
    /**
     * ロゴ押下時処理
     */
    clickLogo() {
      let loggedIn = store.getters['isLoggedIn'];

      // StoreのisLoggedInがFalseであっても、sessionStorageにtokenがある時、ログイン済とする
      if (!loggedIn) {
        const isExistToken = sessionStorage.getItem('token') !== null; // APIのレスポンス次第でtoken: ""になることもあるため""を許容する
        loggedIn = isExistToken;
        store.commit('setIsLoggedIn', { isLoggedIn: isExistToken });
      }

      if (loggedIn) {
        if (this.topFlag) return;
        // ログイン済の場合はトップ画面に遷移
        router.push({
          path: '/top',
        });
      } else {
        if (this.loginFlag) return;
        // 未ログインの場合はログイン画面に遷移
        router.push({
          path: '/login',
        });
      }
    },
  },
  props: {
    color: {
      type: String,
      default: '',
      required: false,
    },
    topFlag: {
      type: Boolean,
      default: false,
    },
    loginFlag: {
      type: Boolean,
      default: false,
    },
  },
};
